/**
* @authllizer/vue (https://github.com/yisraelx/authllizer#readme)
* @version 0.1.0
* @license MIT
* @copyright Yisrael Eliav <yisraelx@gmail.com> (https://github.com/yisraelx)
*/
(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('vue'), require('@authllizer/core')) :
	typeof define === 'function' && define.amd ? define(['exports', 'vue', '@authllizer/core'], factory) :
	(factory((global.authllizer = global.authllizer || {}, global.authllizer.vue = {}),global.Vue,global.authllizer.core));
}(this, (function (exports,Vue,core) { 'use strict';

Vue = Vue && Vue.hasOwnProperty('default') ? Vue['default'] : Vue;

var isInstall = false;
function plugin(Vue$$1, options) {
    if (isInstall) {
        return;
    }
    isInstall = true;
    Vue$$1.authllizer = new core.Authllizer(options);
    Object.defineProperties(Vue$$1.prototype, {
        $auth: {
            get: function () {
                return Vue$$1.authllizer;
            }
        }
    });
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var VueAxiosHttpClient = /** @class */ (function (_super) {
    __extends(VueAxiosHttpClient, _super);
    function VueAxiosHttpClient() {
        return _super.call(this, function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return (_a = Vue).axios.apply(_a, args);
            var _a;
        }) || this;
    }
    VueAxiosHttpClient.prototype.request = function (url, config) {
        config.url = url;
        return this._client(config).then(function (response) { return response.data; });
    };
    return VueAxiosHttpClient;
}(core.BaseHttpClient));

function VueAxiosTokenInterceptor(config) {
    var url = config.url, headers = config.headers;
    if (!headers['Authorization'] && Vue.authllizer.toIntercept(url)) {
        headers['Authorization'] = Vue.authllizer.getToken().toHeader();
    }
    return config;
}

var VueResourceHttpClient = /** @class */ (function (_super) {
    __extends(VueResourceHttpClient, _super);
    function VueResourceHttpClient() {
        return _super.call(this, function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return (_a = Vue).resource.apply(_a, args);
            var _a;
        }) || this;
    }
    VueResourceHttpClient.prototype.request = function (url, options) {
        var method = options.method, data = options.data, params = options.params, headers = options.headers, withCredentials = options.withCredentials;
        var requestOptions = {
            method: method,
            url: url,
            body: data,
            params: params,
            headers: headers,
            credentials: withCredentials
        };
        return this._client(requestOptions).then(function (response) { return response.json(); });
    };
    return VueResourceHttpClient;
}(core.BaseHttpClient));

function VueResourceTokenInterceptor(request, next) {
    var url = request.url, headers = request.headers;
    if (!headers['Authorization'] && Vue.authllizer.toIntercept(url)) {
        headers['Authorization'] = Vue.authllizer.getToken().toHeader();
    }
    next();
}

exports.default = plugin;
exports.VueAxiosHttpClient = VueAxiosHttpClient;
exports.VueAxiosTokenInterceptor = VueAxiosTokenInterceptor;
exports.VueResourceHttpClient = VueResourceHttpClient;
exports.VueResourceTokenInterceptor = VueResourceTokenInterceptor;

Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=authllizer-vue.umd.js.map
